module.exports = __webpack_public_path__ + "img/bacwwan.3ea5f41a.png";